module.exports = __webpack_public_path__ + "static/assets/0fc35fc4350e89249758424b406adc2e.png";